import React from 'react';

// This data structure represents the four steps described in the JSON.
const stepsData = [
  {
    iconName: 'FileText' as const, // Mapped from 'insert_page_break'
    title: 'اختر الصفحة',
    description: 'اختر نوع المستند الذي تحتاجه لتوليد الصفحة.',
  },
  {
    iconName: 'Info' as const, // Mapped from 'info'
    title: 'معلومات المتجر',
    description: 'أدخل تفاصيل نشاطك التجاري لتوليد الصفحة.',
  },
  {
    iconName: 'Sparkles' as const, // Mapped from 'auto_awesome'
    title: 'توليد الصفحة',
    description: 'سيقوم الذكاء الاصطناعي بإنشاء المحتوى فورًا.',
  },
  {
    iconName: 'Copy' as const, // Mapped from 'file_copy'
    title: 'انسخ والصق',
    description: 'انسخ المحتوى النهائي وأضفه إلى موقعك.',
  },
];

const HowItWorks: React.FC = () => {
  return (
    // Replicates the outer Section and Container from the JSON data.
    <section className="py-16">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* This container replicates the styled box from the JSON with its unique background. */}
        <div 
          className="rounded-[38px] px-8 py-10 sm:px-14 bg-[#FCFBF8] border border-black/5"
        >
          {/* Grid layout for the feature cards. */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {stepsData.map((step, index) => (
              <div 
                key={index}
                // Card styling based on the JSON 'Col' element.
                className="flex flex-col p-6 bg-white rounded-2xl border border-[rgba(201,107,4,0.35)] bg-cover bg-left-center"
                style={{
                  backgroundImage: "url('https://assets.lightfunnels.com/account-1/images_library/ec8d5a55-5888-481c-9fcb-db12bd9642db.Asset 8wmmhite.svg')",
                  backgroundPosition: 'center left'
                }}
              >
                <div className="flex items-center mb-2">
                  {/* Icon replaced with a number */}
                  <div className="flex items-center justify-center w-8 h-8 rounded-lg mr-2 flex-shrink-0">
                    <span className="text-lg font-bold text-[var(--color-primary)]">
                      {index + 1}.
                    </span>
                  </div>
                  {/* Card Title */}
                  <h3 className="text-base font-bold text-[#483b36]">
                    {step.title}
                  </h3>
                </div>
                {/* Card Description */}
                <p className="text-sm text-[var(--color-text-body)] opacity-90 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;